/* eslint-disable */
import React, { useCallback, useMemo, useRef, useState } from 'react';
import { connect } from 'dva';
import NativeNav from '@/components/NativeNav';
import { reportClick } from '@/utils/report';
import { jumpToPageByH5 } from '@/utils/fn.js';
import { routeToLoginAndUpdateStatus } from '@/utils/routes';
import { showLoadingToast } from '@/utils/utils.js';
import { useMounted } from '@/utils/hooks';
import BizItem from './components/BizItem';
import BizTabList from './components/BizTabList';
import FilterHeader from './components/FilterHeader';
import BizFilterPanel from './components/BizFilterPanel.js';
import RecuritEmptyPage from './components/RecruitEmptyPage';
import { DEFAULT_FILTER_DATA, MORE_TYPE, RECRUIT_FILTER_OPTIONS } from './config/pars';
import styles from './styles/index.less';
import {
  MENU_COMMUNITY,
  MENU_CONSOLE,
  MENU_GUIDE,
  MENU_RECORD,
  MENU_REWARD,
  MENU_X86_ACT,
  MENU_X86_INVITE,
  RECRUIT_MENU_OPTIONS,
} from './config/recruit.config';
import { openPageNative } from '@/utils/bridge';
import CommunityModal from './components/CommunityModal';

const PAGE_NAME = 'aggregation_page';

const reportTabClick = id => {
  reportClick({
    page_name: PAGE_NAME,
    button_name: 'tab_btn',
    type: id,
  });
};

const scrollTo = id => {
  reportTabClick(id);
  const el = document.getElementById(`biz${id}`);
  if (el) {
    // 120其中有42是导航栏的高度，38是每个业务标题的高度,40是搜索栏高度
    const scrollDistance = el.offsetTop - 120;
    document.body.scrollTop = document.documentElement.scrollTop = scrollDistance;
  }
};

const pageScrollToTop = () => {
  const el = document.getElementById('headerTop');
  if (el) {
    const scrollDistance = el.offsetHeight;
    console.log('scrollDistance: ', scrollDistance);
    document.body.scrollTop = document.documentElement.scrollTop = scrollDistance;
  }
};

const reportBtnClick = (type, otherAttr = {}) => {
  reportClick({
    page_name: PAGE_NAME,
    button_name: `${type}_btn`,
    ...otherAttr,
  });
};

const goTop = () => {
  reportBtnClick('gotop');
  window.scrollTo(0, 0);
};

// 处理请求参数，将Array转成string
const handleArray = (data = {}) => {
  const tempData = {};
  for (const key in data) {
    if (Object.hasOwnProperty.call(data, key)) {
      if (Array.isArray(data[key])) {
        tempData[key] = data[key].join(',');
      } else if (data[key] instanceof Object) {
        tempData[key] = handleArray(data[key]);
      } else {
        tempData[key] = data[key];
      }
    }
  }
  return tempData;
};

const DirectRecruit = ({
  user: { hasLogin, origin },
  recruit: {
    filterOptions,
    bizInfo: { recruiting_list, finished_list },
  },
  loading,
  dispatch,
}) => {
  const hideFilter = useMemo(() => recruiting_list?.length === 0 && finished_list?.length === 0, [
    recruiting_list,
    finished_list,
  ]);
  // 是否是首次查询数据
  const isFirstQuery = useRef(true);
  // tabLIst是否展开
  const [isTabFlat, setTabState] = useState(false);
  // 当前筛选类型
  const [curFilterType, setCurFilterType] = useState('');
  // 是否展示选择面板
  const [showFilterPanel, setShowFilterPanel] = useState(false);
  // 当前已选择的条件
  const [choosenData, setChoosenData] = useState({ ...DEFAULT_FILTER_DATA });
  // 20230801:【SGPWXBOX-2993】加入社群弹窗
  const [showCommunityModal, setShowCommunityModal] = useState(false);

  const toggleTabsState = useCallback(() => {
    reportBtnClick('fold');
    setTabState(isTabFlat => !isTabFlat);
  }, []);

  const handleJoinBtnClick = useCallback(
    id => {
      reportBtnClick('join', { type: id });
      // 校验登录态
      if (hasLogin) {
        const nextPath = `/recruit/direct/apply/${id}`;
        jumpToPageByH5(nextPath);
      } else {
        routeToLoginAndUpdateStatus(0);
      }
    },
    [hasLogin]
  );

  const renderBizList = useCallback(
    (bizList, type) => {
      if (!bizList || bizList.length === 0) return null;
      const isFinish = type === 'finish';
      return bizList.map((item, index) => (
        <BizItem
          key={item.biz_id}
          bizData={item}
          isFinish={isFinish}
          index={index}
          reportBtnClick={reportBtnClick}
          handleJoinBtnClick={handleJoinBtnClick}
        />
      ));
    },
    [hasLogin]
  );

  const handleJumpToResult = useCallback(() => {
    // reportBtnClick('result');
    if (hasLogin) {
      const nextPath = `/recruit/direct/apply-list`;
      jumpToPageByH5(nextPath);
    } else {
      routeToLoginAndUpdateStatus(0);
    }
  }, [hasLogin]);

  const handleTabClick = useCallback(
    (item, type) => {
      // console.log('hasLogin: ', hasLogin);
      const { biz_id, new_change } = item;
      scrollTo(biz_id);
      if (hasLogin && type !== 'finish-list' && new_change) {
        dispatch({
          type: 'recruit/setBizTabRead',
          payload: {
            bizId: biz_id,
          },
        });
      }
    },
    [hasLogin]
  );

  const handleFilterTabClick = useCallback(
    current => {
      pageScrollToTop();
      if (current === curFilterType) {
        setCurFilterType('');
        setShowFilterPanel(showFilterPanel => !showFilterPanel);
      } else {
        setCurFilterType(current);
        setShowFilterPanel(true);
      }
    },
    [curFilterType, showFilterPanel]
  );

  const getBizFilterOptions = useCallback(() => {
    dispatch({
      type: 'recruit/getBizFilterOptions',
      payload: {},
    });
  }, []);

  const handleQueryBiz = useCallback((data = {}) => {
    // console.log('查询data: ', data);
    setChoosenData(data);
    getBizInfoList(data);
  }, []);

  const getBizInfoList = useCallback(data => {
    showLoadingToast();
    const params = handleArray(data);
    let queryParams = {};
    Object.keys(params).reduce((preV, curKey) => {
      if (curKey === MORE_TYPE) {
        queryParams = { ...preV, ...params[curKey] };
      } else {
        queryParams[curKey] = params[curKey];
      }
      return queryParams;
    }, queryParams);
    // console.log('queryParams: ', queryParams);
    dispatch({
      type: 'recruit/getBizInfoList',
      payload: queryParams,
      callback: () => {
        if (isFirstQuery.current) {
          isFirstQuery.current = false;
        } else {
          // console.log('页面滚动');
          pageScrollToTop();
        }
      },
    });
  }, []);

  // 20230801:【SGPWXBOX-2993】
  const handleMenuItemClick = useCallback(
    menuItem => {
      // console.log('点击菜单: ', menuType);
      const { type, url } = menuItem;
      reportBtnClick(type);
      switch (type) {
        case MENU_GUIDE:
        case MENU_CONSOLE:
        case MENU_REWARD:
        case MENU_X86_ACT:
        case MENU_X86_INVITE:
          openPageNative({ url });
          break;
        case MENU_RECORD:
          handleJumpToResult();
          break;
        case MENU_COMMUNITY:
          // 打开加入社群弹窗
          setShowCommunityModal(true);
          break;
        default:
          console.log('点击菜单：', type);
          break;
      }
    },
    [handleJumpToResult]
  );

  const initQuery = useCallback(() => {
    getBizFilterOptions();
    getBizInfoList();
  }, []);

  useMounted(() => {
    initQuery();
  });

  return (
    <NativeNav
      title="定向业务招募"
      isInterceptBack={true}
      otherReportData={{ module: 'recruit' }}
      pageName={PAGE_NAME}
    >
      <div className={`${styles['direct-recruit']} ${hideFilter ? '' : styles['add-padding']}`}>
        <i className={styles['totop']} onClick={goTop} />
        <div className={styles.newHeader} id="headerTop">
          <ul className={styles.menuList}>
            {RECRUIT_MENU_OPTIONS.map(menuItem => (
              <li
                className={`${styles.menuItem} ${styles[menuItem.type]}`}
                key={menuItem.type}
                onClick={() => handleMenuItemClick(menuItem)}
              >
                {menuItem.tag && <span className={styles.tag}>{menuItem.tag}</span>}
                {menuItem.title}
              </li>
            ))}
          </ul>
        </div>
        <FilterHeader
          id="searchBar"
          tabList={RECRUIT_FILTER_OPTIONS}
          handleFilterTabClick={handleFilterTabClick}
          type={curFilterType}
          activeClassName={styles['active-option']}
          className={hideFilter ? styles['noshow-search-bar'] : styles['search-bar']}
        />
        <BizFilterPanel
          origin={origin}
          choosenData={choosenData}
          visible={showFilterPanel}
          type={curFilterType}
          filterOptions={filterOptions}
          closeFilterPanel={() => handleFilterTabClick(curFilterType)}
          onConfirm={handleQueryBiz}
        />
        <div
          className={`${styles['tabs-wrapper']} ${isTabFlat ? styles['flat'] : ''} ${
            recruiting_list.length === 0 && finished_list.length > 0 ? styles['all-finish'] : ''
          }`}
          id="tabs-wrapper"
        >
          <BizTabList tabList={recruiting_list} handleTabClick={handleTabClick} />
          <BizTabList tabList={finished_list} handleTabClick={handleTabClick} type="finish-list" />
          {finished_list.length > 0 && (
            <i
              className={`${styles['control-btn']} ${isTabFlat ? styles['flat'] : ''}`}
              onClick={toggleTabsState}
            />
          )}
        </div>
        <div>
          {renderBizList(recruiting_list)}
          {renderBizList(finished_list, 'finish')}
          {!loading.effects['recruit/getBizInfoList'] &&
            finished_list.length === 0 &&
            recruiting_list.length === 0 && <RecuritEmptyPage onRefresh={initQuery} />}
        </div>
        {showCommunityModal && <CommunityModal handleClose={() => setShowCommunityModal(false)} />}
      </div>
    </NativeNav>
  );
};

export default connect(({ user, recruit, loading }) => ({ user, recruit, loading }))(DirectRecruit);
